/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyJobExecutionStatusResponse {
    getFixupPrototypeFunction() { return PolicyJobExecutionStatusResponse.fixupPrototype; }

    static newInstance(model: Partial<PolicyJobExecutionStatusResponse>): PolicyJobExecutionStatusResponse {
        let obj = Object.assign(new PolicyJobExecutionStatusResponse(), model);
        PolicyJobExecutionStatusResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyJobExecutionStatusResponse>): PolicyJobExecutionStatusResponse {
        if (!model) return null;
        return PolicyJobExecutionStatusResponse.newInstance(<PolicyJobExecutionStatusResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyJobExecutionStatusResponse) {
        if (!obj) return;

        models.PolicyJobExecutionStatusResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyJobExecutionStatusResponse): boolean {
        Object.setPrototypeOf(obj, PolicyJobExecutionStatusResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.failures) {
            for (let val of this.failures) {
                models.PolicyFailureData.fixupPrototype(val);
            }
        }
    }

    total_count: string;

    /**
     * page count
     */
    page_count: string;

    /**
     * Reason for policy failure
     */
    failures: Array<models.PolicyFailureData>;

}
